import React, { useState } from 'react'
import DefaultLayout from '../../components/layout/DefaultLayout'
import dummayimage from '../../assets/images/dummay/dummay.png';
import { useFormik } from 'formik';
import EmailField from '../../components/Form/EmailField';
import { forgetPasswordService } from '../../services/authServices';
import {useNavigate} from 'react-router-dom'
import ClipLoader from "react-spinners/ClipLoader";
import errorModel from '../../components/Errors/ErrorModel';
export default function ForgetPassword() {
  const navigate = useNavigate();

 const [loader, setLoader] = useState(false);
  const formik = useFormik({
    initialValues:{
      email:''
    },
    onSubmit:async(values)=>{
      setLoader(true)
      const result = await forgetPasswordService(values);
      console.log(result);
      if(result.status===true){
        setLoader(false)
        errorModel('success',result.message)
        navigate('/verification')
      }
      else{
        setLoader(false)
        errorModel('error',result.message)
      }
    }
  })
  return (
    <DefaultLayout>
      <div className=" ">
        <div className=" h-screen overflow-hidden">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 h-full">
      <div className='pt-10 pl-2 md:pl-20'>
        <h1 className='h1'>Forget Password</h1>
        <p className="p pt-4 md:pt-10">Lorem, ipsum dolor sit amet consectetur adipisicing elit. Rerum nisi architecto iste veniam, voluptates aspernatur dolorem, ratione voluptatibus iusto nobis omnis magni expedita esse ipsam dolore. Nam ullam dolor aliquid.</p>
        <div className="pt-5">
          <form onSubmit={formik.handleSubmit} >
          <EmailField
                        label="Email"
                        name="email"
                        placeholder="Email"
                        formik={formik}

                      />
                  
                      <div className="py-8 flex items-center justify-center">
                      <button type='submit' className='btn-primary'>
                send
                {loader ?
                      <ClipLoader
        color={"#ffffff"}
        loading={true}
        // cssOverride={override}
        size={15}
        className="relative top-1 left-2"
        aria-label="Loading "
        data-testid="loader"
      />
      : null}
              </button>
                      </div>
            
          </form>
        </div>
      </div>
      <div className='h-screen'>
        <img src={dummayimage} className="w-full h-full" alt="" />
      </div>
    </div>
        </div>
      </div>
   
    </DefaultLayout>
  )
}
